export default "__VITE_ASSET__BsJ3pMx___"